export const selectService = [
    {
        id: "fixed",
        name: "Servicio a precio cerrado",
        selected: false
    },
    {
        id: "showLead",
        name: "Elige un tipo de presupuesto:",
        selected: false
    },
];

export const selectLead = [
    {
        id: "leadThree",
        name: "Pedir 3 hasta presupuestos",
        selected: false
    },
    {
        id: "leadOne",
        name: "Pedir 1 presupuesto",
        selected: false
    }
];
